import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import LogoPartenaireComponent from './LogoPartenaireComponent';
import LinkButtonComponent from '../button/LinkButtonComponent';
import { getMerchantCardUrl } from '../../services/partner/utils';
import CodePromoBlocPartenaireComponent from './CodePromoBlocPartenaireComponent';
import CashbackBlocPartenaireComponent from './CashbackBlocPartenaireComponent';

import './PartnerBlockComponent.scss';

class PartnerBlockComponent extends React.Component {
    render() {
        const { JENPROFITE, partner, urlCustom, isCodePromo } = this.props;
        const Children = isCodePromo
            ? CodePromoBlocPartenaireComponent
            : CashbackBlocPartenaireComponent;
        const urlFicheMarchand = partner ? getMerchantCardUrl(partner) : null;

        return (
            partner && (
                <article className="bloc-partenaire txtcenter flex-container-v flex-center-alt">
                    <LogoPartenaireComponent
                        partenaire={partner}
                        url={urlFicheMarchand}
                        title={partner.name ? partner.name : ''}
                        cssClass="logo"
                    />
                    <hr />
                    <Children partner={partner} cssClassContainer="blp-reduction" />
                    <div className="bt-conteneur w100">
                        <LinkButtonComponent
                            to={urlCustom ? urlCustom : urlFicheMarchand}
                            title={partner.name ? partner.name : ''}
                            text={JENPROFITE}
                            color="main"
                        />
                    </div>
                </article>
            )
        );
    }
}

PartnerBlockComponent.propTypes = {
    urlCustom: PropTypes.string,
    isCodePromo: PropTypes.bool,
    partner: PropTypes.object
};

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
    return {
        JENPROFITE: state.i18n.feature.partenaire.jenprofite
    };
}

export default connect(mapStateToProps)(PartnerBlockComponent);



// WEBPACK FOOTER //
// ./src/components/partner/PartnerBlockComponent.js